<template>
  <div class="alert" :role="role" :class="computedStyleClasses">
    <div class="d-flex flex-row">
      <div class="alert-icon">
        <ips-icon v-if="iconType" :icon="iconType" :class="iconClasses"></ips-icon>
      </div>
      <div>
        <div v-if="title" class="alert-heading">{{ title }}</div>
        <div v-if="message" class="alert-body">{{ message }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import IpsIcon from '@ipscape/ips-icon';
import { alertMixin } from '../../../mixins/index.js';

export default {
  name: 'IpsAlert',
  components: {
    IpsIcon,
  },
  mixins: [alertMixin],
  computed: {
    computedStyleClasses() {
      const classesArray = ['ips'];
      if (this.variant === 'message') {
        classesArray.push('alert-secondary');
      } else {
        classesArray.push(`alert-${this.variant}`);
      }
      classesArray.push(this.alertBackgroundClass);
      return classesArray;
    },
    alertBackgroundClass() {
      switch (this.variant) {
        case 'danger':
          return 'alert-red';
        case 'info':
          return 'alert-blue';
        case 'success':
          return 'alert-green';
        case 'warning':
          return 'alert-yellow';
        case 'message':
        default:
          return 'alert-gray';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'IpsAlert';
</style>
